exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ProgressiveImage--image{transition:filter .3s ease-out;width:100%;position:absolute;height:100%;object-fit:cover;top:0}", ""]);

// exports
